export default class TripEntity {
    static getEntityData(elem: any) {
        return {
            date: (elem.querySelector("#trip_date") as HTMLInputElement).value,
            transportation: (elem.querySelector("#trip_transportation option:checked") as HTMLInputElement).value,
            distance: (elem.querySelector("#trip_distance") as HTMLInputElement).value,
        }
    }
}